import * as React from 'react';
import { HeaderFeature } from '@app/src/common/header';
import { FooterFeature } from '@app/src/common/footer';
import { NotFoundFeature } from './notFound';

export const NotFound: React.SFC = () => (
  <React.Fragment>
    <HeaderFeature />
    <NotFoundFeature />
    <FooterFeature isDisplay={true} />
  </React.Fragment>
);
